<template>
  <layout>
    <page-header :header="$t('calendars.calendar_header')" />
    <div ref="content" class="content">
      <div class="card">
        <div class="card-header header-elements-inline">
          <h6 class="card-title">{{ $t('calendars.dashboard_title') }}</h6>
          <div class="header-elements"></div>
        </div>

        <div class="card-body" style="">
          <div class="">
            <div v-if="username">
              {{ $t('calendars.hello') }}, {{ username }}
            </div>
            <div class="form-group">
              <button
                v-if="!signed"
                id="authorize_button"
                class="btn btn-primary"
                @click="handleAuthClick"
              >
                {{ $t('calendars.authorize') }}
              </button>
              <button
                v-if="signed"
                id="signout_button"
                class="btn btn-light"
                @click="handleSignoutClick"
              >
                {{ $t('calendars.logout') }}
              </button>
              <a
                v-if="signed"
                id="go_to_my_calenadar"
                :href="
                  'https://www.google.com/calendar/render?cid=' +
                    calendars[0].id
                "
                target="_blank"
                class="btn btn-light"
              >
                {{ $t('calendars.sync_my_calendar') }}
              </a>
              <button
                v-if="signed"
                id="refresh_button"
                class="btn btn-primary float-right"
                @click="handleRefreshClick"
              >
                {{ $t('calendars.btn_refresh') }}
              </button>
            </div>
            <div v-if="calendars.length">
              <div v-if="signed">
                <div
                  v-for="(calendar, index) in calendars"
                  :key="index"
                  :title="calendar.summary"
                >
                  <b-card-text>
                    <iframe
                      :src="
                        'https://calendar.google.com/calendar/embed?src=' +
                          calendar.id
                      "
                      class="calendar_frame"
                      style="border: 0"
                      width="100%"
                      height="600"
                      frameborder="0"
                      scrolling="no"
                    ></iframe>
                  </b-card-text>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import { AdminPageHeader } from 'stylemix-vue-admin'
import { default as GoogleAuth2 } from './calendar.api'

export default {
  name: 'Calendar',

  components: {
    AdminPageHeader,
  },
  mixins: [GoogleAuth2],

  data() {
    return {
      calendar_id: 'primary',
      calendars: [],
      username: null,
      gemail: '',
    }
  },

  computed: {
    signed: {
      get() {
        if (typeof this.auth2.isSignedIn == 'undefined') return false
        if (this.auth2.isSignedIn.get()) {
          this.innerfillCalendarsList()
          let user = this.auth2.currentUser.get().getBasicProfile()
          if (typeof user.ig !== 'undefined') {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.username = user.ig
          }
          // Send Acl
          let gmail = user.U3
          let promise = this.$http.put('google/setgmail', { gmail: gmail })
          this.$uiBlocker(promise, this.$refs.content)
        }
        return this.auth2.isSignedIn.get()
      },
      set() {
        return false
      },
    },
  },

  mounted() {
    this.getGMail()
  },

  methods: {
    getGMail() {
      let self = this
      let promise = this.$http.get('google/getgmail')
      this.$uiBlocker(promise, this.$refs.content)
      promise.then(result => {
        if (typeof result.data.gmail !== 'undefined') {
          self.gemail = result.data.gmail
        }
      })
    },

    saveGMail() {
      let promise = this.$http.put('google/setgmail', { gmail: this.gemail })
      this.$uiBlocker(promise, this.$refs.content)
    },

    innerfillCalendarsList() {
      let self = this
      let promise = this.$http.get('google/c-ulist')
      this.$uiBlocker(promise, this.$refs.content)
      promise.then(result => {
        let temp = []
        let calendars = result.data.calendars
        for (let i in calendars) temp.push(calendars[i])
        self.calendars = temp
      })
    },

    handleAuthClick() {
      this.auth2.grantOfflineAccess()
    },
    handleSignoutClick() {
      this.auth2.disconnect()
    },
    handleRefreshClick() {
      window.location.reload(false)
    },
  },
}
</script>

<style type="text/css">
div.tabs {
  width: 100%;
}
.btn-light + .btn-light {
  margin-left: 15px;
}
</style>
